import { createSelector } from 'reselect';

const getLoading = (state) => state.loaders;

export const getLoadingState = createSelector(
    (state) => getLoading(state),
    (state, types) => types,
    (loaders, types) => types.some((type) => loaders[type])
);
